/**
 * Core Questions - Bộ câu hỏi cốt lõi tinh gọn
 * 
 * 8 câu hỏi đại diện cho tất cả pattern TCM:
 * - Bát Cương (Hàn/Nhiệt, Hư/Thực)
 * - 9 Thể chất
 * - Triệu chứng chính
 * 
 * Mỗi câu được thiết kế để đánh giá nhiều pattern cùng lúc,
 * tránh trùng lặp và giảm thời gian nhập liệu.
 */

export const CORE_QUESTIONS = [
    {
        id: 'energy',
        text: 'Mức năng lượng của bạn gần đây?',
        icon: '⚡',
        category: 'khí',
        options: [
            { label: 'Rất mệt mỏi', value: 'very_low', patterns: { qixu: 4, yangxu: 2 } },
            { label: 'Hay mệt', value: 'low', patterns: { qixu: 3, yangxu: 1 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Khỏe mạnh', value: 'high', patterns: { thuc: 1 } },
            { label: 'Rất khỏe', value: 'very_high', patterns: { thuc: 2 } }
        ]
    },
    {
        id: 'temperature',
        text: 'Bạn thường cảm thấy lạnh hay nóng?',
        icon: '🌡️',
        category: 'hàn_nhiệt',
        options: [
            { label: 'Rất sợ lạnh', value: 'very_cold', patterns: { han: 4, yangxu: 3 } },
            { label: 'Hơi sợ lạnh', value: 'cold', patterns: { han: 2, yangxu: 1 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Hơi sợ nóng', value: 'hot', patterns: { nhiet: 2, yinxu: 1 } },
            { label: 'Rất sợ nóng', value: 'very_hot', patterns: { nhiet: 4, yinxu: 3 } }
        ]
    },
    {
        id: 'extremities',
        text: 'Tay chân bạn thường như thế nào?',
        icon: '🖐️',
        category: 'tứ chi',
        options: [
            { label: 'Lạnh, tê bì', value: 'very_cold', patterns: { yangxu: 4, han: 2 } },
            { label: 'Hơi lạnh', value: 'cold', patterns: { yangxu: 2, han: 1 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Ấm nóng', value: 'warm', patterns: { yinxu: 2, nhiet: 1 } },
            { label: 'Nóng bừng', value: 'very_hot', patterns: { yinxu: 4, nhiet: 2 } }
        ]
    },
    {
        id: 'sleep',
        text: 'Chất lượng giấc ngủ của bạn?',
        icon: '😴',
        category: 'tâm thần',
        options: [
            { label: 'Khó ngủ, hay thức giấc', value: 'insomnia', patterns: { yinxu: 3, qiyu: 2 } },
            { label: 'Ngủ không sâu', value: 'light', patterns: { yinxu: 2, qiyu: 1 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Ngủ nhiều, khó dậy', value: 'excess', patterns: { tanshi: 2, yangxu: 1 } },
            { label: 'Ngủ rất nhiều', value: 'very_excess', patterns: { tanshi: 3, yangxu: 2 } }
        ]
    },
    {
        id: 'digestion',
        text: 'Hệ tiêu hóa của bạn như thế nào?',
        icon: '🍽️',
        category: 'tỳ vị',
        options: [
            { label: 'Hay đầy bụng, khó tiêu', value: 'bloated', patterns: { tanshi: 3, qixu: 2 } },
            { label: 'Ăn ít, chán ăn', value: 'poor', patterns: { qixu: 3, yangxu: 1 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Hay đói, ăn nhiều', value: 'hungry', patterns: { shire: 2, nhiet: 1 } },
            { label: 'Nóng ruột, ợ chua', value: 'acid', patterns: { nhiet: 3, shire: 2 } }
        ]
    },
    {
        id: 'pain',
        text: 'Bạn có thường xuyên đau nhức không?',
        icon: '💊',
        category: 'thống',
        options: [
            { label: 'Không đau', value: 'none', patterns: {} },
            { label: 'Đau nhẹ, thoáng qua', value: 'mild', patterns: { qiyu: 1 } },
            { label: 'Đau theo thời tiết', value: 'weather', patterns: { tanshi: 2, han: 1 } },
            { label: 'Đau cố định một chỗ', value: 'fixed', patterns: { huyetu: 3 } },
            { label: 'Đau nhiều nơi', value: 'multiple', patterns: { qiyu: 2, tanshi: 2 } }
        ]
    },
    {
        id: 'mood',
        text: 'Tâm trạng của bạn gần đây?',
        icon: '🧠',
        category: 'tâm',
        options: [
            { label: 'Lo âu, căng thẳng', value: 'anxious', patterns: { qiyu: 3, yinxu: 1 } },
            { label: 'Dễ cáu gắt', value: 'irritable', patterns: { nhiet: 2, qiyu: 2 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Trầm, uể oải', value: 'low', patterns: { qixu: 2, tanshi: 1 } },
            { label: 'Bi quan, buồn chán', value: 'depressed', patterns: { qiyu: 3, qixu: 2 } }
        ]
    },
    {
        id: 'skin',
        text: 'Tình trạng da của bạn?',
        icon: '✨',
        category: 'bì phu',
        options: [
            { label: 'Khô, bong tróc', value: 'dry', patterns: { yinxu: 3, huyetu: 1 } },
            { label: 'Hơi khô', value: 'slightly_dry', patterns: { yinxu: 2 } },
            { label: 'Bình thường', value: 'normal', patterns: {} },
            { label: 'Nhờn, hay mụn', value: 'oily', patterns: { shire: 3, tanshi: 2 } },
            { label: 'Rất nhờn, mụn nhiều', value: 'very_oily', patterns: { shire: 4, tanshi: 3 } }
        ]
    }
];

// Pattern mappings for analysis
export const PATTERN_NAMES = {
    han: 'Hàn chứng',
    nhiet: 'Nhiệt chứng',
    qixu: 'Khí hư',
    yangxu: 'Dương hư',
    yinxu: 'Âm hư',
    tanshi: 'Đàm thấp',
    shire: 'Thấp nhiệt',
    qiyu: 'Khí uất',
    huyetu: 'Huyết ứ',
    thuc: 'Thực chứng'
};

// Calculate pattern scores from answers
export function calculatePatternScores(answers) {
    const scores = {};

    CORE_QUESTIONS.forEach(q => {
        const answer = answers[q.id];
        if (answer) {
            const option = q.options.find(o => o.value === answer);
            if (option?.patterns) {
                Object.entries(option.patterns).forEach(([pattern, score]) => {
                    scores[pattern] = (scores[pattern] || 0) + score;
                });
            }
        }
    });

    return scores;
}

// Get top patterns from scores
export function getTopPatterns(scores, limit = 3) {
    return Object.entries(scores)
        .filter(([_, score]) => score > 0)
        .sort((a, b) => b[1] - a[1])
        .slice(0, limit)
        .map(([pattern, score]) => ({
            id: pattern,
            name: PATTERN_NAMES[pattern] || pattern,
            score,
            confidence: Math.min(score / 10, 1) // Normalize to 0-1
        }));
}

// Convert to format compatible with existing services
export function convertToServiceFormat(answers) {
    const patternScores = calculatePatternScores(answers);
    const topPatterns = getTopPatterns(patternScores);

    return {
        raw: answers,
        patterns: topPatterns,
        scores: patternScores,
        analyzed: {
            bat_cuong: {
                han_nhiet: patternScores.han > patternScores.nhiet ? 'han' : patternScores.nhiet > patternScores.han ? 'nhiet' : 'balanced',
                hu_thuc: (patternScores.qixu || 0) + (patternScores.yangxu || 0) + (patternScores.yinxu || 0) > (patternScores.thuc || 0) ? 'hu' : 'thuc'
            },
            primary_patterns: topPatterns
        },
        timestamp: new Date().toISOString()
    };
}
